import { type CoreMoney } from "@vega-core/models/money";

/**
 * Converts a CoreMoney object to a payload format suitable for API requests.
 * Ensures amount is converted to a number (MoneyField outputs strings).
 * Returns undefined if the input is undefined.
 */
export const toMoneyPayload = (money?: CoreMoney) => {
  if (!money) return undefined;

  return {
    amount:
      typeof money.amount === "string"
        ? parseFloat(money.amount)
        : money.amount,
    currency: money.currency,
  };
};
